import { nangmanCenterRoutes } from './nangman-center-routes';
import { manseRoutes } from './manse-routes';
import { sajuRoutes } from './saju-routes';
import { calendarRoutes } from './calendar-routes';
import { mobileRoutes } from './mobile-routes';
import { mypageRoutes } from './mypage-routes';
import { purchaseRoutes } from './purchase-routes';
import SajuResultPage from '@/pages/saju-result/index.vue';
import SajuInputPage from '@/pages/saju-input/index.vue';
import AnalysisPage from '@/pages/analysis/index.vue';

// 기타 라우트
const miscRoutes = [
  {
    path: '/saju-result/:id',
    component: SajuResultPage,
    meta: {
      layout: 'manse',
    },
  },
  {
    path: '/saju-input',
    component: SajuInputPage,
    meta: {
      layout: 'manse',
    },
  },
  {
    path: '/analysis/:id',
    component: AnalysisPage,
    meta: {
      layout: 'analysis',
    },
  },
];

// 통합 export
export const routes = [
  ...miscRoutes,
  ...mobileRoutes,
  ...mypageRoutes,
  ...purchaseRoutes,
  ...manseRoutes,
  ...sajuRoutes,
  ...nangmanCenterRoutes,
  ...calendarRoutes,
];
